import { TPromoCompilationType } from '../../types/promoSelection';
import { IApplicationState } from '../../types/redux';

export const selectPromoCompilationLabel =
  (type: TPromoCompilationType) =>
  (state: IApplicationState): string => {
    const {
      promosPage: { lastChanceDiscount, topPromos },
    } = state;
    switch (type) {
      case 'topPromos':
        return topPromos.subTitle;
      case 'lastChanceDiscount':
        return lastChanceDiscount.subTitle;
    }
  };
